export const SCOPE = 'data:sharing';

export const INIT = `${SCOPE}/INIT`;
export const START_SHARE = `${SCOPE}/START_SHARE`;
